import React from 'react';
import { FieldWrapper, Label } from '../styles';
import { isEmpty } from '../../../helpers/common';
import { TextAreaField } from './styles';

/**
 * TextArea component props
 * @typedef {Object} Props
 * @property {string} [label] - Optional label displayed above the text area
 * @property {string} [placeHolder] - Placeholder text shown inside the text area
 * @property {string} [value] - Current value of the text area
 * @property {React.ChangeEventHandler<HTMLTextAreaElement>} [onChange] - Change handler for the text area value
 * @property {string} [maxWidth] - Optional max-width CSS value for the text area
 * @property {string} [height] - Optional height CSS value for the text area
 * @property {string} [className] - Optional class name passed to the wrapper
 */
interface Props {
  label?: string;
  placeHolder?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  maxWidth?: string;
  height?: string;
  className?: string;
  isDisabled?: boolean;
  fieldWrapperWidth?: string;
}

const TextArea: React.FC<Props> = ({
  label,
  placeHolder,
  value,
  onChange,
  maxWidth,
  height,
  className,
  isDisabled,
  fieldWrapperWidth
}) => {
  return (
    <FieldWrapper fieldWrapperWidth={fieldWrapperWidth} className={className}>
      {!isEmpty(label) && <Label isDisabled={isDisabled}>{label}</Label>}
      <TextAreaField
        placeholder={placeHolder}
        value={value}
        onChange={onChange}
        height={height}
        maxWidth={maxWidth}
        disabled={isDisabled}
      />
    </FieldWrapper>
  );
};

export default TextArea;
